import { ListViewProvider } from '../core/ListViewProvider'
import { QueryRequestProvider } from '../core/QueryRequestProvider'
import { QueryResponseProvider } from '../core/QueryResponseProvider'
import { useFetchCommon } from '../../../../../../_metronic/helpers/crud-helper/useQuery'
// import Certificate2 from './Certificate2'
import Certificate2 from './Certificate2'
import DatePicker from 'react-datepicker'
import { useEffect, useState, useRef } from 'react'
import { useAuth } from '../../../../auth'
import DownloadPDFButton from '../table/columns/DownloadPDFButton'
import Select from 'react-select'

const initialState = {
  startDate: '',
  endDate: '',
  facility: '',
}
interface FacilityOption {
  label: string;
  value: string;
}
const QualityList = () => {


  interface SupplyChainOption {
    label: string;
    value: string;
  }

  const [supplyChainOptions, setSupplyChainOptions] = useState<SupplyChainOption[]>([])
  const [selectedSupplyChain, setSelectedSupplyChain] = useState('')

  const [userSelectedData, setUserSelectedData] = useState<any>(initialState)
  const [searchResult, setSearchResult] = useState(false)
  const { isFacilityManager, auth, currentUser }: any = useAuth()
  const [selectedFacilities, setSelectedFacilities] = useState<string[]>([])
  const { responseData: facilityTypeList } = useFetchCommon({
    api: 'users?page=0&size=10&type=PICKUP_POINT',
    label: ['personalDetails', 'name'],
    isDropDown: false,
    isEnabled: !isFacilityManager,
  })
  const [facilityDropdown, setFacilityDropdown] = useState<FacilityOption[]>([])

  const [analytics, setAnalytics] = useState(null)

  const certificateRef = useRef(null)
  const printStyles = `
  @media print {
    body * {
      visibility: hidden;
    }
    .printable-certificate, .printable-certificate * {
      visibility: visible;
    }
    .printable-certificate {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
    }
  }
`;

  // Add the style tag to the document head
  useEffect(() => {
    const styleSheet = document.createElement("style");
    styleSheet.innerText = printStyles;
    document.head.appendChild(styleSheet);

    return () => {
      document.head.removeChild(styleSheet);
    };
  }, []);


  useEffect(() => {
    const fetchSupplyChainData = async () => {
      try {
        const authData = JSON.parse(localStorage.getItem('kt-auth-react-v') || '{}')
        const token = authData?.data?.token

        const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}users?page=0&size=10&type=FRANCHISE`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        })

        if (response.ok) {
          const data = await response.json()
          const options: SupplyChainOption[] = data.map((item: any) => ({
            label: item?.personalDetails?.name || 'N/A',
            value: item.id
          }))
          setSupplyChainOptions(options)
        }
      } catch (error) {
        console.error('Error fetching supply chain data:', error)
      }
    }

    fetchSupplyChainData()
  }, [])

  useEffect(() => {
    if (facilityTypeList.length) {
      setFacilityDropdown(
        facilityTypeList.map((x) => ({ label: x?.personalDetails?.name ?? '', value: x.id }))
      )
    }
  }, [facilityTypeList])

  useEffect(() => {
    if (searchResult && selectedSupplyChain && userSelectedData.startDate && userSelectedData.endDate) {
      const fetchAnalytics = async () => {
        try {
          const authData = JSON.parse(localStorage.getItem('kt-auth-react-v') || '{}')
          const token = authData?.data?.token

          // const response = await fetch(
          //   `${process.env.REACT_APP_BASE_API_URL}supplyChainReport?start_date=${formatDateForAPI(userSelectedData.startDate)}&end_date=${formatDateForAPI(userSelectedData.endDate)}`,
          //   {
          //     headers: {
          //       'Authorization': `Bearer ${token}`,
          //       'Content-Type': 'application/json',
          //       'franchiseeId': selectedSupplyChain
          //     }
          //   }
          // )
          const facilityIdsParam = selectedFacilities.length > 0
            ? `&facilityIds=${selectedFacilities.join(',')}`
            : ''

          const response = await fetch(
            `${process.env.REACT_APP_BASE_API_URL}supplyChainReport?start_date=${formatDateForAPI(userSelectedData.startDate)}&end_date=${formatDateForAPI(userSelectedData.endDate)}${facilityIdsParam}`,
            {
              headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'franchiseeId': selectedSupplyChain
              }
            }
          )


          if (response.ok) {
            const data = await response.json()
            setAnalytics(data)
          }
        } catch (error) {
          console.error('Error fetching analytics:', error)
        }
      }

      fetchAnalytics()
    }
  }, [searchResult]) // Only depend on searchResult

  const formatDateForAPI = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return `${String(date.getMonth() + 1).padStart(2, '0')}/${String(date.getDate()).padStart(2, '0')}/${date.getFullYear()}`;
  }

  const formatDateRange = () => {
    if (!userSelectedData.startDate || !userSelectedData.endDate) return '';
    return `${formatDateForAPI(userSelectedData.startDate)} to ${formatDateForAPI(userSelectedData.endDate)}`;
  };

  const handleChange = (name, value) => {
    setSearchResult(false)
    setAnalytics(null) // Clear analytics data when inputs change
    setUserSelectedData({ ...userSelectedData, [name]: value })
  }

  const url =
    process.env.REACT_APP_BASE_API_URL +
    `download/pickupPoints/${userSelectedData.facility}}?start_date=${formatDateForAPI(userSelectedData.startDate)}&end_date=${formatDateForAPI(userSelectedData.endDate)}`

  return (
    <>
      <div className="card mb-3">
        <div className="card-body">
          <div className="row g-3">
            {/* First Row */}
            <div className="col-md-6 col-lg-3">
              <label className='form-label fs-6 fw-bold'>Select supply chain</label>
              <select
                className='form-control form-control-solid'
                value={selectedSupplyChain}
                onChange={(e) => {
                  setSelectedSupplyChain(e.target.value)
                  setSearchResult(false)
                  setAnalytics(null)
                }}
                style={{
                  backgroundColor: '#ffffff',
                  border: '1px solid #dddddd',
                  color: '#000000',
                }}
              >
                <option value="">Select supply chain</option>
                {supplyChainOptions.map(option => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-md-6 col-lg-3">
              <label className='form-label fs-6 fw-bold'>Select Material Hub (Optional)</label>
              <Select
                isMulti
                options={facilityDropdown}
                value={facilityDropdown.filter(f => selectedFacilities.includes(f.value))}
                onChange={(selected) => {
                  const values = selected ? selected.map(s => s.value) : []
                  setSelectedFacilities(values)
                  setSearchResult(false)
                  setAnalytics(null)
                }}
                placeholder="Select Material Hub "
                styles={{
                  control: (base) => ({
                    ...base,
                    backgroundColor: '#ffffff',
                    border: '1px solid #dddddd',
                    minHeight: '44px'
                  })
                }}
              />
            </div>

            <div className="col-md-12 col-lg-6">
              <div className="row g-2">
                <div className="col-md-6 col-lg-3">
                  <label className='form-label fs-6 fw-bold'>Start date</label> <br />
                  <DatePicker
                    customInput={
                      <input
                        className='form-control form-control-solid'
                        style={{
                          backgroundColor: '#ffffff',
                          border: '1px solid #dddddd',
                          color: '#000000',
                          width: '100%'
                        }}
                      />
                    }
                    placeholderText={`Select start date`}
                    selected={userSelectedData.startDate ? new Date(userSelectedData.startDate) : null}
                    onChange={(date) => {
                      const normalizedDate = new Date(date.getFullYear(), date.getMonth(), date.getDate())
                      const utcDate = new Date(
                        Date.UTC(
                          normalizedDate.getFullYear(),
                          normalizedDate.getMonth(),
                          normalizedDate.getDate()
                        )
                      )
                      handleChange('startDate', utcDate.toISOString())
                    }}
                  />
                </div>

                <div className="col-md-6 col-lg-3">
                  <label className='form-label fs-6 fw-bold'>End date</label><br />
                  <DatePicker
                    customInput={
                      <input
                        className='form-control form-control-solid'
                        style={{
                          backgroundColor: '#ffffff',
                          border: '1px solid #dddddd',
                          color: '#000000',
                          width: '100%'
                        }}
                      />
                    }
                    placeholderText={`Select end date`}
                    selected={userSelectedData.endDate ? new Date(userSelectedData.endDate) : null}
                    onChange={(date) => {
                      const normalizedDate = new Date(date.getFullYear(), date.getMonth(), date.getDate())
                      const utcDate = new Date(
                        Date.UTC(
                          normalizedDate.getFullYear(),
                          normalizedDate.getMonth(),
                          normalizedDate.getDate()
                        )
                      )
                      handleChange('endDate', utcDate.toISOString())
                    }}
                  />
                </div>
              </div>
            </div>

            {/* Buttons Row */}
            <div className="col-12">
              <div className='d-flex gap-2'>
                <button
                  type='button'
                  style={{ backgroundColor: '#12B886' }}
                  onClick={() => {
                    setSearchResult(false)
                    setTimeout(() => setSearchResult(true), 0)
                  }}
                  className='btn btn-primary fw-bold px-6'
                  disabled={!userSelectedData.startDate || !userSelectedData.endDate}
                >
                  Apply
                </button>
                <button
                  type='button'
                  onClick={() => window.print()}
                  disabled={!userSelectedData.startDate || !userSelectedData.endDate || !analytics}
                  className='btn btn-primary fw-bold px-6'
                  style={{ backgroundColor: '#333333' }}
                >
                  Download PDF
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {analytics && (
        <div className="printable-certificate">
          <Certificate2
            inventory={analytics}
            graphData={analytics}
            supplierData={[]}
            analyticsMonth={{}}
            month={formatDateRange()}
          />
        </div>
      )}
    </>
  )
}

const SupplyChainAdmin = () => (
  <QueryRequestProvider initialValue={{ enabled: false }}>
    <QueryResponseProvider>
      <ListViewProvider>
        <QualityList />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export { SupplyChainAdmin }